import { getGlobalEventsLogs } from '@cian/events-log';

import { EModalActionTypes } from './types';
import { actionGenerator } from '../../../../packages/redux-utils';
import { TThunkAction } from '../../types/redux';

export const modalOpenNext = actionGenerator(EModalActionTypes.ModalOpen);

// FIXME после отпила виджета нужно убрать событие в events log и перейти полностью на экшен
export function modalOpen(): TThunkAction<Promise<void>> {
  return async dispatch => {
    const globalLog = getGlobalEventsLogs();

    globalLog.produce('feedback-frontend', { type: 'open', value: true });

    dispatch(modalOpenNext());
  };
}
